import { Injectable } from '@angular/core';
import { GoogleTagManagerService } from 'angular-google-tag-manager';

@Injectable({
  providedIn: 'root'
})
export class GTMService {

  constructor(private gtmService: GoogleTagManagerService) { }

  // -------------------------------------
  /** Pushes tag to Google Tag Manager DataLayer */
  analyticsEvent(event: string, category: string, action: string, value: number, item, customDimensions?) {
    this.gtmService.pushTag({
      'event': event,
      'category': category,
      'action': action,
      'label': item,
      'value': value,
      customDimensions
    })
  }

  ecommerceAnalyticsEvent(item, list, category, action) {
    let impressions = []
    item.forEach(element => {
      impressions.push({
        'name': element.id,
        'list': list
      })
    });

    this.gtmService.pushTag({
      'event': 'engagement',
      'ecommerce': {
        'currencyCode': 'USD',
        'impressions': impressions
      },
      'category': category,
      'action': action,
      'value': 1
    })
  }

  ecommerceProductAnalyticsEvent(item, customDimensions?) {
    this.gtmService.pushTag({
      "event": "productClick",
      "action": "ecommerce product click",
      "ecommerce": {
        "click": {
          "actionField": {
            "list": "product clicked"
          },
          "products": [{
            "id": item.id,
            "name": item.product_name,
            "price": "",
            "brand": item.product_brand,
            "category": item.product_sub_category_2_name,
          }]
        }
      },
      customDimensions
    });
  }
}
